import React, { useEffect, useState } from 'react';
import { Card, Tag, Empty, Typography } from 'antd';
import { DatabaseOutlined, WarningOutlined, DownOutlined, RightOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import api from '../../api/axios';

const { Text } = Typography;

// Her gece calisan otomatik yedekleme icin - eger bir sonraki gece calismazsa
// (cron/sunucu sorunu) burada fark edilsin diye 30 saatten eski yedek "gecikti"
// sayiliyor (gunluk cron + biraz tolerans payi).
const STALE_HOURS = 30;

const BackupStatusPanel = () => {
  const [collapsed, setCollapsed] = useState(true);
  const [latest, setLatest] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get('/backups')
      .then((res) => setLatest((res.data || [])[0] || null))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  if (loading || error) return null;

  const isStale = latest && dayjs().diff(dayjs(latest.created_at), 'hour') > STALE_HOURS;

  return (
    <Card
      size="small"
      title={
        <span
          className="cursor-pointer select-none flex items-center gap-2"
          onClick={() => setCollapsed((c) => !c)}
        >
          {collapsed ? <RightOutlined style={{ fontSize: 11, color: '#9ca3af' }} /> : <DownOutlined style={{ fontSize: 11, color: '#9ca3af' }} />}
          <DatabaseOutlined style={{ color: '#1677ff' }} />
          Veritabanı Yedekleme Durumu
          {latest && (isStale
            ? <Tag icon={<WarningOutlined />} color="red" style={{ margin: 0 }}>Gecikmiş</Tag>
            : <Tag color="green" style={{ margin: 0 }}>Güncel</Tag>)}
        </span>
      }
      style={{ marginBottom: 16 }}
    >
      {!collapsed && (
        !latest ? (
          <Empty description="Hiç yedek bulunamadı." image={Empty.PRESENTED_IMAGE_SIMPLE} />
        ) : (
          <div className="flex items-center gap-3 flex-wrap">
            <Text>Son yedek: <strong>{dayjs(latest.created_at).format('DD.MM.YYYY HH:mm')}</strong></Text>
            <Text type="secondary">({latest.size_mb} MB)</Text>
            {isStale && (
              <Tag icon={<WarningOutlined />} color="red">
                {dayjs().diff(dayjs(latest.created_at), 'hour')} saattir yeni yedek yok
              </Tag>
            )}
          </div>
        )
      )}
    </Card>
  );
};

export default BackupStatusPanel;
